import { FC, useContext } from "react";

import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { StepTwoFormContext } from "../../../../contexts";
import { QuotationInfoContext, QuotationStep } from "../../../../../../../shared";

import './index.css';

interface HeaderTabPersonalEffectsProps {
  id: number;
  areTabActionsAllowed: boolean;
}

export const HeaderTabPersonalEffects: FC<HeaderTabPersonalEffectsProps> = ({ id, areTabActionsAllowed }) => {

  const { tabs, setKeyTabToDelete, setShowModal } = useContext(StepTwoFormContext);
  const { currentStep } = useContext(QuotationInfoContext);

  const onMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '2') {
      setKeyTabToDelete(id);
      setShowModal(true);
    }
  };

  const items = [
    {
      key: '2',
      label: 'Eliminar',
      danger: true,
      disabled: tabs.length === 1
    }
  ];

  return (
    <div className="header-tab-personal-effects">
      Efectos Personales {id}
      {currentStep === QuotationStep.TWO && areTabActionsAllowed && (
        <Dropdown menu={{ items, onClick: onMenuClick }} trigger={['click']} arrow>
          <Button type="text" className="header-tab-personal-effects-button">
            <MoreOutlined />
          </Button>
        </Dropdown>
      )}
    </div>
  )
}